/**
 * auth.guard.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot
} from "@angular/router";
import { AuthService } from "../auth/auth.service";

@Injectable()
export class AuthGuard implements CanActivate, CanLoad
{
  constructor (private router : Router, private auth : AuthService) {}

  private hasRedirectTarget (data : any)
    : data is {post_auth_redirect : string}
  {
    return (data && typeof data.post_auth_redirect === "string");
  }

  public run (data : any, url : string) : boolean
  {
    if (this.auth.authenticated)
    {
      return true;
    }

    if (this.hasRedirectTarget(data))
    {
      this.auth.redirectTo = [data.post_auth_redirect];
    }
    else
    {
      // If no target is specified, return to the current route target.
      this.auth.redirectTo = [url];
    }
    console.log("redir to", this.auth.redirectTo);

    // Navigate to the login page
    this.router.navigate(["/login"]);

    // Redirection should kill the existing navigation, but just in case (and in
    // the interest of satisfying the method's semantics), we return false.
    return false;
  }

  public canActivate (
    route : ActivatedRouteSnapshot,
    state : RouterStateSnapshot
  ) : boolean
  {
    return this.run(route.data, state.url);
  }

  public canLoad (route : Route) : boolean
  {
    return this.run(route.data, "/home");
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/routing/auth.guard.ts